import API from '../../services/API'
import router from '../../router/index'
import {
    AUTH_GETTER_IDTOKEN,
    AUTH_MUTATION_LOG_IN,
    AUTH_MUTATION_LOG_OUT,
    AUTH_MUTATION_SET_IDTOKEN,
    AUTH_MUTATION_SIGN_UP,
    AUTH_ACTION_LOG_IN,
    AUTH_ACTION_LOG_OUT,
    AUTH_ACTION_RECOVER_PASSWORD,
    AUTH_ACTION_REQUEST_IDTOKEN,
    AUTH_ACTION_SIGN_UP
} from './auth-types'
import OAlert from '../../utils/OAlert/OAlert'
import i18n from '../../assets/i18n/lang'

export default {
    namespaced: true,

    state: {
        loggedIn: false,
        idToken: ''
    },

    getters: {
        [AUTH_GETTER_IDTOKEN]: state => state.idToken
    },

    mutations: {
        [AUTH_MUTATION_LOG_IN] (state) {
            state.loggedIn = true
            router.replace('/')
        },
        [AUTH_MUTATION_LOG_OUT] (state, rootState) {
            state.loggedIn = false
            rootState.burial.burial = {}
            rootState.ceremony.ceremony = {}
            rootState.contacts.contacts = []
            rootState.documents.documents = {}
            rootState.guardians.guardians = []
            rootState.invitations.invitations = []
            rootState.pets.pets = []
            rootState.profile.profile = {}
            rootState.proteges.proteges = [] // TODO: delete currentAllInfo
            rootState.title.title = {}
            rootState.speeches.speeches = {}
            rootState.music.musics = {}
            router.replace('/login')
        },
        [AUTH_MUTATION_SET_IDTOKEN] (state, payload) {
            state.idToken = payload
        },
        [AUTH_MUTATION_SIGN_UP] (state) {
            router.replace('/login')
        }
    },

    actions: {
        [AUTH_ACTION_LOG_IN] ({ commit }, payload) {
            API.logIn(payload)
                .then(() => {
                    commit(AUTH_MUTATION_LOG_IN)
                    OAlert.showSuccess('', i18n.t('feedback.authSucLogin'))
                })
                .catch((error) => {
                    OAlert.showFailure('', i18n.t('feedback.authFailLogin'))
                    console.log(error.message)
                })
        },
        [AUTH_ACTION_LOG_OUT] ({ commit, rootState }, payload) {
            API.logOut()
                .then(() => {
                    commit(AUTH_MUTATION_LOG_OUT, rootState)
                    OAlert.showSuccess('', i18n.t('feedback.authSucLogout'))
                })
                .catch((error) => {
                    OAlert.showFailure('', i18n.t('feedback.authFailLogout'))
                    console.log(error.message)
                })
        },
        [AUTH_ACTION_RECOVER_PASSWORD] ({ commit }, payload) {
            API.recoverPassword(payload)
                .then(() => OAlert.showSuccess('', i18n.t('feedback.authSucRecoverPass')))
                .catch((error) => {
                    OAlert.showFailure('', i18n.t('feedback.authFailRecoverPass'))
                    console.log(error.message)
                })
        },
        [AUTH_ACTION_REQUEST_IDTOKEN] ({ commit }) {
            API.getIdToken()
                .then((idToken) => commit(AUTH_MUTATION_SET_IDTOKEN, idToken))
                .catch((error) => console.log(error.message))
        },
        [AUTH_ACTION_SIGN_UP] ({ commit }, payload) {
            API.signUp(payload)
                .then(() => {
                    commit(AUTH_MUTATION_SIGN_UP)
                    OAlert.showSuccess('', i18n.t('feedback.authSucSignup'))
                })
                .catch((error) => {
                    OAlert.showFailure('', i18n.t('feedback.authFailSignup'))
                    console.log(error.message)
                })
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js